import * as yup from 'yup';

// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Required')
    .min(2, 'Name cannot be less than 2 letters'),
  lastName: yup
    .string()
    .required('Required')
    .min(2, 'Name cannot be less than 2 letters'),
  email: yup.string().email('Invalid email').required('Required'),
  text: yup.string().required('Required'),
});
